import { Component, OnInit, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { AnalyticsService } from 'app/shared/analytics/analytics.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { FluxoVestibularService } from '../shared/fluxoVestibular.service';

import { DadosVestibular } from 'models/dados-vestibular';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './sobre-curso.component.html',
  styleUrls: ['./sobre-curso.component.scss'],
  animations: [routerTransition],
})
export class SobreCursoComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  dadosVestibular: DadosVestibular = undefined;
  dadosVestibularSubscription: Subscription;
  cursoSelecionado: any;
  podeVoltar = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoVestibularService: FluxoVestibularService,
    private analytics: AnalyticsService,
  ) { }

  ngOnInit() {
    this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
    this.podeVoltar = this.fluxoVestibularService.passoAtualRetornavel();
    if (!this.dadosVestibular.vestibular) {

      this.dadosVestibularSubscription = this.fluxoVestibularService.dadosVestibularMessage$.subscribe(() => {
        this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
        this.dadosVestibularSubscription.unsubscribe();
        this.init();
      });

    } else {
      this.init();
      this.analytics.registrar(
        `Vestibular`,
        `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
        'Sobre o curso',
      );
    }
  }

  init() {
    this.cursoSelecionado = this.dadosVestibular.cursoSelecionado;
  }

  goNext() {
    this.fluxoVestibularService.proximoPasso({
      cursoSelecionado: this.cursoSelecionado,
    });

    this.analytics.registrar('Vestibular', 'Curso', this.cursoSelecionado);

    const proximaRota = this.fluxoVestibularService.proximaRota();
    this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });
  }

  voltar() {
    this.fluxoVestibularService.voltarPasso();

    const rotaAnterior = this.fluxoVestibularService.rotaAnterior();
    this.router.navigate([`../${rotaAnterior}`], { relativeTo: this.route });
  }

  getTurnoDesc(turno) {
    return this.fluxoVestibularService.getTurnoDesc(turno);
  }
}
